module.exports = __webpack_public_path__ + "static/media/99gal19.3138ee7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal19.jpg
// module id = 394
// module chunks = 0